import axios from "axios";

// Create axios instance with conditional baseURL
const axiosConfig = axios.create({
  baseURL: 'https://api-tisradar.emit.mg',
      
  //baseURL: "http://192.168.88.136:9093/",
  // Add default headers for better caching
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request interceptor to add caching-related headers
axiosConfig.interceptors.request.use(
  (config) => {
    // For GET requests, we can add cache control headers
    if (config.method === "get") {
      // Default cache duration - can be overridden by specific endpoints
      config.headers["Cache-Control"] =
        config.headers["Cache-Control"] || "max-age=300"; // 5 minutes

      // Add timestamp for certain dynamic endpoints to prevent caching
      if (
        config.url?.includes("/uploads/favoris") ||
        config.url?.includes("/toggleFavoris")
      ) {
        const timestamp = new Date().getTime();
        config.params = { ...config.params, _t: timestamp };
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for handling response caching
axiosConfig.interceptors.response.use(
  (response) => {
    // For certain endpoints that return stable data, we can add client hints for longer caching
    if (
      response.config.method === "get" &&
      (response.config.url?.includes("/uploads/category") ||
        response.config.url?.includes("/uploads/course/"))
    ) {
      // Add cache hints for stable content
      response.headers["Cache-Control"] = "max-age=3600"; // 1 hour for stable content
    }

    return response;
  },
  (error) => Promise.reject(error)
);

// Enable browser caching for responses with appropriate content types
if (typeof window !== "undefined" && "caches" in window) {
  const CACHE_NAME = "tisradar-api-cache";

  // Function to determine if a request should be cached
  const shouldCacheRequest = (url) => {
    // Add logic to determine which URLs should be cached
    return (
      url.includes("/uploads/category") ||
      url.includes("/uploads/course/") ||
      url.includes("/uploads/download/")
    );
  };

  // Create a special handler for resources that should be cached
  axiosConfig.interceptors.response.use(async (response) => {
    // Only cache GET requests and specific content types
    if (
      response.config.method === "get" &&
      shouldCacheRequest(response.config.url || "")
    ) {
      try {
        const cache = await caches.open(CACHE_NAME);

        // Store the response in cache
        const requestUrl = new URL(
          response.config.url || "",
          response.config.baseURL || window.location.origin
        );

        // Create a proper response object for the cache
        let responseToCache;

        if (response.data instanceof Blob) {
          // For blob responses (like images)
          responseToCache = new Response(response.data, {
            status: response.status,
            statusText: response.statusText,
            headers: {
              "Content-Type": response.headers["content-type"],
              "Cache-Control": "max-age=86400", // 24 hours for files
            },
          });
        } else {
          // For JSON responses
          responseToCache = new Response(JSON.stringify(response.data), {
            status: response.status,
            statusText: response.statusText,
            headers: {
              "Content-Type": "application/json",
              "Cache-Control":
                response.headers["cache-control"] || "max-age=3600",
            },
          });
        }

        await cache.put(requestUrl.toString(), responseToCache);
      } catch (err) {
        console.warn("Failed to cache API response:", err);
      }
    }
    return response;
  });
}

export default axiosConfig;

// Helper function to clear the API cache (useful for force refresh)
export const clearApiCache = async () => {
  if (typeof window !== "undefined" && "caches" in window) {
    try {
      await caches.delete("tisradar-api-cache");
      console.log("API cache cleared successfully");
      return true;
    } catch (err) {
      console.error("Failed to clear API cache:", err);
      return false;
    }
  }
  return false;
};
